
  <div class="mt-5" *ngIf="accountPlans">
    <div class="text-center">
      <h3>Select a Plan for Your School</h3>
      <!-- <a class="text-link text-sm" href="https://impata.com/pricing" target="_blank"><i class="fa fa-info-circle"></i> View More</a> -->
    </div>
    <div class="text-center pt-5"><span>*All plans are post-paid and billed every 30 days</span></div>
    <div class="d-flex justify-content-center gap-1.5 flex-wrap mt-3">
      <div class="card card-block shadow-sm-darker mb-0" *ngFor="let plan of this.accountPlans; index as i">   
        <div class="card-body plan-body">
          <h4 class="text-center mb-0">
            <div class="font-weight-normal text-primary text-md">{{plan.name}}</div>
            <div *ngIf="!plan.altPriceText" class="mt-2 font-weight-700 text-2xl">₦{{util.numberWithCommas(plan.nairaPricePerStudent)}}</div>
            <div *ngIf="plan.altPriceText" class="mt-2 font-weight-700 text-2xl">{{plan.altPriceText}}</div>
            <div [ngStyle]="{'visibility': plan.altPriceText ? 'hidden' : 'unset'}" class="font-weight-normal text-xs text-body"> monthly / per Student</div>
          </h4>
          <ul class="list-unstyled text-sm mb-4 py-4 border-b-border-line plan-features">
            <!-- <li>Index: {{i}}</li> -->
            <li class="d-flex align-items-center my-2" *ngIf="i > 0">
              <span class="mr-2">
                <i class="inclusion-icon far fa-check-circle text-primary" title="Included"></i>
              </span>
              <span><b>Everything in {{this.accountPlans[i - 1].name}}</b></span> 
            </li>
            <li *ngFor="let feature of plan.features | keyvalue"  class="d-flex align-items-center my-2" [ngClass]="{'hidden-feature': !feature.value.display || feature.value.minimumTierSNo != plan.sNo}">
              <span class="feature-left-span">
                <span class="mr-2">
                  <i class="inclusion-icon far fa-check-circle text-primary" title="Included"></i>
                  <!-- <i *ngIf="!plan.paymentIntegration" class="inclusion-icon far fa-times-circle text-red" title="Not Included"></i> -->
                </span>
                <span>{{feature.value.name}}</span> 
              </span>
              <span class="feature-right-span" *ngIf="feature.value.description">
                <button type="button" data-toggle="dropdown" aria-expanded="false" title="{{feature.value.description}}" class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body">
                  <i class="fa fa-info-circle"></i>
                </button>
                <div class="info-popup dropdown-menu p-2">
                  <p class="form-info-p">{{feature.value.description}}</p>
                </div>
              </span>
            </li>
          </ul>
          <div class="text-center select-plan-button-div">
            <input *ngIf="plan.allowUserSelect" class="btn w-100 planSlt" [disabled]="plan.id == this.schooInfo.accountTierId"  type="button" [attr.data-id]="plan.id" [attr.value]="plan.id != this.schooInfo.accountTierId ? 'Select Plan' : 'Current Plan'" value="Select Plan"  (click)="onPlanSelect(plan.id)" />  
            <input *ngIf="!plan.allowUserSelect" class="btn w-100 planSlt" disabled type="button" [attr.data-id]="plan.id" [attr.value]="plan.id != this.schooInfo.accountTierId ? 'Contact Us' : 'Current Plan'" value="Select Plan" />  
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row " *ngIf="selectedPlan > 0 && !this.schooInfo.freePlanSelected">
      <p class="h3 col-12 "> Enter Billing Information for School <span class="right" style="float: right;">
          <a href=""> Learn more </a></span></p>
      <div class="card center">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label class="form-control-label" for="phone">Invoice Name <span
                    class="text-red">[required]</span> </label>
                <input type="text" minlength="10" [(ngModel)]="schooInfo.billingName" #billingName
                  name="billingName" class="form-control" [required]="!this.schooInfo.freePlanSelected"
                  id="phone" placeholder="The name to show on the invoice">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-control-label" for="phone">Invoice Phone <span
                    class="text-red">[required]</span></label>
                <input type="text" minlength="10" [(ngModel)]="schooInfo.billingPhone" #billingPhone
                  name="billingPhone" class="form-control" [required]="!this.schooInfo.freePlanSelected"
                  id="phone" placeholder="Phone Number to recieve billing alerts">
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label class="form-control-label" for="schoolemail">Invoice Email address <span
                    class="text-red">[required]</span></label>
                <input type="email" [(ngModel)]="schooInfo.billingEmail" #billingEmail name="billingEmail"
                  class="form-control" id="billingemail" [required]="!this.schooInfo.freePlanSelected"
                  placeholder="Email to send invoice to">
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label class="form-control-label" for="phone">Invoice Postal Address</label>
                <textarea rows="3" [(ngModel)]="schooInfo.billingAddress" #billingAddress
                  name="billingAddress" class="form-control" id="phone"
                  placeholder="The Address to show on the invoice"></textarea>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>